import React from 'react';
import { Modal as RsModal } from 'rsuite';
import { X } from 'lucide-react';
import { ARIA_LABELS } from '../../constants/strings';
import styles from './Modal.module.scss';

type ModalSize = 'sm' | 'md' | 'lg';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: ModalSize;
  footer?: React.ReactNode;
  className?: string;
}

const sizeMap: Record<ModalSize, 'xs' | 'sm' | 'md'> = {
  sm: 'xs',
  md: 'sm',
  lg: 'md',
};

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, size = 'md', footer, className }) => {
  return (
    <RsModal open={isOpen} onClose={onClose} size={sizeMap[size]} backdrop="static" className={className}>
      <RsModal.Header closeButton={false}>
        <div className={styles.modalHeader}>
          <RsModal.Title>{title}</RsModal.Title>
          {/* Own button rather than RSuite's, so the icon matches the app's lucide set. */}
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label={ARIA_LABELS.CLOSE_MODAL}>
            <X size={18} />
          </button>
        </div>
      </RsModal.Header>
      <RsModal.Body>{children}</RsModal.Body>
      {footer && <RsModal.Footer>{footer}</RsModal.Footer>}
    </RsModal>
  );
};
